import { render, staticRenderFns } from "./DialogConsentTypeDepartment.vue?vue&type=template&id=323057a0&scoped=true&"
import script from "./DialogConsentTypeDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogConsentTypeDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentTypeDepartment.vue?vue&type=style&index=0&id=323057a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323057a0",
  null
  
)

export default component.exports